import { createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-48667158"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "menu" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<p class=\"menu-options\" data-v-48667158>Home</p><p class=\"menu-options\" data-v-48667158>About</p><p class=\"menu-options\" data-v-48667158>Contact</p><p class=\"menu-options\" data-v-48667158>Blog</p><p class=\"menu-options\" data-v-48667158>Careers</p>", 5)
const _hoisted_7 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_7))
}